// EmailModalForm.js
import React, { useState, useEffect } from 'react';
import './Modal.css';
import supabase from './supabaseClient'; // Make sure this path is correct
import CryptoJS from 'crypto-js';
import TranslateText from '../../translation/TranslateText'; // Adjust the import path as needed

const EmailModalForm = ({ isOpen, handleClose, handleContinue }) => {
  const [email, setEmail] = useState('');
  const [hasSubmittedEmail, setHasSubmittedEmail] = useState(false);

  const storageKey = 'userEmail';
  const expirationDays = 15;
  // Use a secret key for encryption from env (or a fallback)
  const secretKey = process.env.REACT_APP_SECRET_KEY || 'default-secret-key';

  const setEmailInLocalStorage = (email) => {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + expirationDays);
    const emailData = {
      email,
      expiration: expirationDate.getTime(),
    };
    const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(emailData), secretKey).toString();
    localStorage.setItem(storageKey, encryptedData);
  };

  const getEmailFromLocalStorage = () => {
    const encryptedData = localStorage.getItem(storageKey);
    if (!encryptedData) return null;

    try {
      const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);

      if (!decryptedData) {
        throw new Error('Decryption failed, resulting in empty data');
      }

      const parsedData = JSON.parse(decryptedData);
      const { email, expiration } = parsedData;

      if (new Date().getTime() > expiration) {
        localStorage.removeItem(storageKey);
        return null;
      }
      return email;
    } catch (e) {
      console.error('Error decrypting or parsing data:', e);
      localStorage.removeItem(storageKey);
      return null;
    }
  };

  useEffect(() => {
    const storedEmail = getEmailFromLocalStorage();
    if (storedEmail) {
      setHasSubmittedEmail(true);
      handleContinue(); // Automatically continue if email is already stored
    }
  }, [handleContinue]);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleContinueClick = async () => {
    if (email) {
      // Insert the email into your Supabase table named "Email"
      const { data, error } = await supabase
        .from('Email') // Change this if your table name is different
        .insert([{ email }]);

      if (error) {
        console.error('Error inserting email:', error);
      } else {
        console.log('Email submitted:', data);
        setEmailInLocalStorage(email);
        setHasSubmittedEmail(true);
        handleContinue();
      }
    }
  };

  if (!isOpen || hasSubmittedEmail) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <button className="close-button" onClick={handleClose}>X</button>
        <h3 style={{ textAlign: 'center', paddingBottom: '25px' }}>
          <TranslateText text="Enter Your Email To Continue" />
        </h3>
        <input 
          type="email" 
          value={email} 
          onChange={handleEmailChange} 
          placeholder="Enter your email" 
          required 
        />
        <div className="modal-actions">
          <button className="continue-button" onClick={handleContinueClick}>
            <TranslateText text="Continue" />
          </button>
          <button className="no-thanks-button" onClick={handleClose}>
            <TranslateText text="No thanks" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailModalForm;











// import React, { useState, useEffect } from 'react';
// import './Modal.css';
// import supabase from './supabaseClient'; // Make sure this path is correct
// import CryptoJS from 'crypto-js';
// import TranslateText from '../../translation/TranslateText'; // Adjust the import path as needed

// const EmailModalForm = ({ isOpen, handleClose, handleContinue }) => {
//   const [email, setEmail] = useState('');
//   const [hasSubmittedEmail, setHasSubmittedEmail] = useState(false);

//   const storageKey = 'userEmail';
//   const expirationDays = 15;
//   const secretKey = process.env.REACT_APP_SECRET_KEY || 'default-secret-key'; // Securely manage your secret key

//   const setEmailInLocalStorage = (email) => {
//     const expirationDate = new Date();
//     expirationDate.setDate(expirationDate.getDate() + expirationDays);
//     const emailData = {
//       email,
//       expiration: expirationDate.getTime(),
//     };
//     const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(emailData), secretKey).toString();
//     localStorage.setItem(storageKey, encryptedData);
//   };

//   const getEmailFromLocalStorage = () => {
//     const encryptedData = localStorage.getItem(storageKey);
//     if (!encryptedData) return null;

//     try {
//       const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
//       const decryptedData = bytes.toString(CryptoJS.enc.Utf8);

//       // Ensure the decrypted data is valid JSON
//       if (!decryptedData) {
//         throw new Error('Decryption failed, resulting in empty data');
//       }

//       const parsedData = JSON.parse(decryptedData);
//       const { email, expiration } = parsedData;

//       if (new Date().getTime() > expiration) {
//         localStorage.removeItem(storageKey);
//         return null;
//       }
//       return email;
//     } catch (e) {
//       console.error('Error decrypting or parsing data:', e);
//       localStorage.removeItem(storageKey);
//       return null;
//     }
//   };

//   useEffect(() => {
//     const storedEmail = getEmailFromLocalStorage();
//     if (storedEmail) {
//       setHasSubmittedEmail(true);
//       handleContinue(); // Automatically continue if email is already stored
//     }
//   }, [handleContinue]);

//   const handleEmailChange = (e) => {
//     setEmail(e.target.value);
//   };

//   const handleContinueClick = async () => {
//     if (email) {
//       // Handle email submission to Supabase
//       const { data, error } = await supabase
//         .from('Email') // Replace 'email' with your actual table name if different
//         .insert([{ email }]);

//       if (error) {
//         console.error('Error inserting email:', error);
//       } else {
//         console.log('Email submitted:', data);
//         setEmailInLocalStorage(email);
//         setHasSubmittedEmail(true);
//         handleContinue();
//       }
//     }
//   };

//   if (!isOpen || hasSubmittedEmail) return null;

//   return (
//     <div className="modal-overlay">
//       <div className="modal-container">
//         <button className="close-button" onClick={handleClose}>X</button>
//         <h3 style={{textAlign: 'center', paddingBottom: '25px'}}>
//           <TranslateText text="Enter Your Email To Continue" />
//         </h3>
//         <input 
//           type="email" 
//           value={email} 
//           onChange={handleEmailChange} 
//           placeholder="Enter your email" 
//           required 
//         />
//         <div className="modal-actions">
//           <button className="continue-button" onClick={handleContinueClick}>
//             <TranslateText text="Continue" />
//           </button>
//           <button className="no-thanks-button" onClick={handleClose}>
//             <TranslateText text="No thanks" />
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EmailModalForm;

